// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xi_a bhc_a bhc_x","StrollerDetailRating__muted":"xi_b bhc_fm"};